/**
 * Mobile nav toggle open and menu items open
 */
export const mobileNav = () => {
	const theButton = document.querySelector('#mobile-nav-butt');
	const theButtonClose = document.querySelector('#mobile-nav-butt-close');
	const theTrigger = document.querySelectorAll('.mobile-nav');

	/* setting the menu active classes for the mobile menu. Removed the header active as it wasn't needed */
	const submenus = document.querySelectorAll('.dropdown-arrow');
	for (let i = 0; i < submenus.length; i++) {
		submenus[i].addEventListener('click', function (e) {
			e.preventDefault();
			e.stopPropagation();
			const active = document.querySelector('.menu-active');
			if (active) {
				active.classList.remove('menu-active');
			}
			e.currentTarget.classList.toggle('menu-active');
		});
	}
	if (theButton) {
		theButton.onclick = function () {
			for (const x of theTrigger) {
				x.classList.add('mob-nav-active');
			}
		};

		theButtonClose.onclick = function () {
			for (const x of theTrigger) {
				x.classList.remove('mob-nav-active');
			}
		};
	}

	const searchButton = document.querySelector('#search-button');
	const closeSearch = document.querySelector('#close-search');
	const searchNav = document.querySelectorAll('.search-bar');

	if (searchButton) {
		searchButton.onclick = function () {
			for (const x of searchNav) {
				x.classList.toggle('search-active');
			}
		};
	}
	if (closeSearch) {
		closeSearch.onclick = function () {
			for (const x of searchNav) {
				x.classList.remove('search-active');
			}
		};
	}
};
